(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gd-faq-page"]) return;
  try {
    
function setupGlanceFaq(root) {
  if (root.dataset.faqReady) return;
  root.dataset.faqReady = 'true';
  const groups = Array.from(root.querySelectorAll('.gd-faq__group'));
  const links = Array.from(root.querySelectorAll('.gd-faq__nav a'));
  function select(hash) {
    const id = hash.replace('#', '');
    const valid = id === 'faq-all' || groups.some(group => group.id === id);
    const active = valid ? id : groups[0].id;
    groups.forEach(group => { group.hidden = active !== 'faq-all' && group.id !== active; });
    links.forEach(link => {
      if (link.getAttribute('href') === '#' + active) link.setAttribute('aria-current', 'true');
      else link.removeAttribute('aria-current');
    });
  }
  root.querySelector('.gd-faq__nav').addEventListener('click', event => {
    const link = event.target.closest('a');
    if (!link) return;
    event.preventDefault();
    const hash = link.getAttribute('href');
    history.pushState(null, '', hash);
    select(hash);
  });
  window.addEventListener('hashchange', () => select(window.location.hash));
  window.addEventListener('popstate', () => select(window.location.hash));
  select(window.location.hash);
}
document.querySelectorAll('.gd-faq-page').forEach(setupGlanceFaq);
document.addEventListener('shopify:section:load', event => {
  event.target.querySelectorAll('.gd-faq-page').forEach(setupGlanceFaq);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["glance-design-footer"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded',()=>{if(window.matchMedia('(max-width:749px)').matches){document.querySelectorAll('.gd-footer__group').forEach(d=>d.removeAttribute('open'));}})

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
